"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as a } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: l, size: e = 24 } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = a(), c = l !== null && l !== void 0 ? l : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: h } = n();
    return h.match(/^o2-new/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: c,
            d: "M2 21h20V7.92c0-1.239-1-2.251-2.224-2.251h-8.294a.73.73 0 0 1-.52-.227l-1.74-1.766A2.07 2.07 0 0 0 7.668 3H4.224C3 3 2 4.012 2 5.252zm18.516-1.498H3.48V5.215c0-.413.336-.75.744-.75h3.479c.188 0 .372.078.52.228l1.74 1.761c.407.45.963.676 1.555.676h8.258c.408 0 .74.337.74.75z"
        })
    })) : h.match(/^o2/i) ? /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: c,
            d: "M2 21h20V7.92c0-1.239-1-2.251-2.224-2.251h-8.294a.73.73 0 0 1-.52-.227l-1.74-1.766A2.07 2.07 0 0 0 7.668 3H4.224C3 3 2 4.012 2 5.252zm18.516-1.498H3.48V5.215c0-.413.336-.75.744-.75h3.479c.188 0 .372.078.52.228l1.74 1.761c.407.45.963.676 1.555.676h8.258c.408 0 .74.337.74.75z"
        })
    })) : /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ o("path", {
            fill: c,
            d: "M3.62 20.207h16.76c.806 0 1.461-.656 1.461-1.463V7.46c0-.807-.655-1.462-1.462-1.462h-8.154v-.732c0-.806-.658-1.462-1.465-1.462H3.62c-.81 0-1.465.656-1.465 1.462v13.477c0 .81.658 1.465 1.465 1.465M3.432 5.265c0-.106.082-.187.188-.187h7.14c.107 0 .188.081.188.187v1.37c0 .353.285.639.638.639h8.793c.107 0 .188.081.188.188v11.282a.19.19 0 0 1-.188.188H3.62a.184.184 0 0 1-.188-.187z"
        })
    }));
}, p = s;
export { p as default };
